import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message, MessageService } from 'primeng/api';
import { Usuario } from 'src/app/core/models/usuario.model';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { BackgroundImageService } from 'src/app/core/services/background-image.service';
import { WeblabService } from 'src/app/core/services/weblab.service';

@Component({
  selector: 'app-esqueci-senha',
  templateUrl: './esqueci-senha.component.html',
  styleUrls: ['./esqueci-senha.component.scss']
})
export class EsqueciSenhaComponent implements OnInit {
  usuario: string;
  img: string = '';
  loading: boolean = false;
  sucesso: boolean = false;
  error: boolean = false;
  invalid: boolean = false;
  imagemLogoBase64: string;

  constructor(
    private backgroundImageService: BackgroundImageService,
    private authenticationService: AuthenticationService,
    private service: WeblabService,
    private router: Router) { }

  ngOnInit(): void {
    this.imagemLogoBase64 = this.authenticationService.obterEmpresa.logo_laboratorio;

    this.img = this.backgroundImageService.getBackgroundImage();

    if (!this.img)
      this.img = this.backgroundImageService.randonImage();

    this.usuario = this.authenticationService.usuario;
  }

  voltarLogin() {
    this.router.navigate(['/', this.authenticationService.obterEmpresa.token_acesso]);
  }

  redefinirSenha() {
    this.loading = true;

    if (!this.usuario) {
      setTimeout(() => {
        this.invalid = true;
        this.sucesso = false;
        this.error = false;
        this.loading = false;
      }, 1000);
      return;
    }

    this.invalid = false;


    this.service.esqueciSenha(this.usuario).subscribe({
      next: (resp) => this.esqueciSenhaSucesso(resp),
      error: (erro: any) => this.esqueciSenhaErro(erro),
    });
  }

  private esqueciSenhaSucesso(resp: any) {
    this.loading = false;
    this.sucesso = true;
    this.error = false;
    this.usuario = '';
  }

  private esqueciSenhaErro(erro: any) {
    this.loading = false;
    this.sucesso = false;
    this.error = true;
  }

}